import { Link } from "react-router-dom";
import { siteInfo, tickerWords } from "@/mocks/site";
import { getFeaturedPosts, formatDate, formatViews } from "@/lib/content";

export default function Hero() {
  const featured = getFeaturedPosts()[0];
  const marquee = [...tickerWords, ...tickerWords];

  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-100">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-accent-200/50 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 left-1/4 h-80 w-80 rounded-full bg-primary-100/70 blur-3xl"></div>

      <div className="relative w-full overflow-hidden border-b border-background-200/80 bg-background-50/70 py-2.5">
        <div className="flex w-max animate-marquee-x items-center gap-8 whitespace-nowrap">
          {marquee.map((word, index) => (
            <span key={`${word}-${index}`} className="flex items-center gap-2 text-xs text-foreground-600">
              <i className="ri-sparkling-2-fill text-accent-500"></i>
              {word}
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-10 md:px-8 md:py-14 lg:grid-cols-12 lg:gap-10">
        <div className="flex flex-col justify-center lg:col-span-7">
          <p className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-bubble-chart-line"></i>
            福利吃瓜 · 每日更新
          </p>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            {siteInfo.name}
          </h1>
          <p className="mt-3 font-heading text-xl font-bold text-foreground-800 md:text-2xl">
            福利吃瓜，名场面、爆笑高能与小甜瓜全都有
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {siteInfo.intro}这里是轻松向的吃瓜角落，专治无聊时刻，点开就能收获快乐，适合碎片时间随手刷一刷。
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/category/mingchangmian"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line text-base"></i>
              开始吃瓜
            </Link>
            <Link
              to="/category/lezi"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
            >
              看本周乐子
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <dl className="mt-9 grid max-w-lg grid-cols-3 gap-4 border-t border-background-200 pt-6">
            <div>
              <dt className="text-xs text-foreground-500">陪伴读者</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {siteInfo.readers}
              </dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">每日精选</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {siteInfo.dailyPicks} 条
              </dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">始于</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {siteInfo.startYear}
              </dd>
            </div>
          </dl>
        </div>

        {featured && (
          <div className="lg:col-span-5">
            <Link
              to={`/post/${featured.id}`}
              className="group relative block h-full overflow-hidden rounded-xl2 border border-background-200 bg-background-50"
            >
              <div className="relative h-56 w-full overflow-hidden bg-background-200 md:h-72">
                <img
                  src={featured.cover}
                  alt={featured.title}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-star-smile-line"></i>
                  编辑精选
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h2 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                  {featured.title}
                </h2>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                  <span>{formatDate(featured.date)}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatViews(featured.views)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-3-line"></i>
                    {formatViews(featured.likes)}
                  </span>
                </div>
              </div>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}